module.exports = __webpack_public_path__ + "img/location@2x.ead222f.webp";